import { get } from "lodash";
import React from "react";
import {
	DateField,
	EmailField,
	List as RaList,
	NumberField,
	TextField,
	useTranslate,
} from "react-admin";
import ResponsiveList from "../components/lists/ResponsiveList";
import { useListStyles } from "../components/lists/useStyles";
import perPage from "../utils/per-page";
import Actions from "./Actions";
import Empty from "./Empty";
import Filters from "./Filters";

const Datagrid = (props) => {
	const hasStartAt = !!get(props, "filterValues.start_at");
	const hasEndAt = !!get(props, "filterValues.end_at");
	const hasDay = !!get(props, "filterValues.day");
	const showInsights = hasStartAt || hasEndAt || hasDay;
	return (
		<ResponsiveList
			{...props}
			mobileHeader={
				<React.Fragment>
					<TextField
						source="name"
						label="resources.users.fields.profile.name"
						style={{ fontWeight: "bold" }}
						variant="h6"
					/>
					{showInsights && (
						<NumberField
							source="amount"
							options={{ style: "currency", currency: "EUR" }}
							sortable={false}
						/>
					)}
				</React.Fragment>
			}
			mobileBody={
				<React.Fragment>
					<EmailField source="email" />
					<DateField source="created" showTime color="textSecondary" />
				</React.Fragment>
			}
		>
			<TextField
				source="name"
				label="resources.users.fields.profile.name"
				style={{ fontWeight: "bold" }}
			/>
			<EmailField source="email" />
			<DateField source="created" showTime />
			{showInsights && (
				<NumberField
					source="amount"
					sortable={false}
					options={{ style: "currency", currency: "EUR" }}
				/>
			)}
		</ResponsiveList>
	);
};

const List = (props) => {
	const classes = useListStyles();
	const translate = useTranslate();
	return (
		<RaList
			{...props}
			perPage={perPage(50, 25)}
			filters={<Filters />}
			sort={{ field: "created", order: "DESC" }}
			actions={<Actions />}
			bulkActionButtons={false}
			empty={<Empty />}
			classes={classes}
			title={translate("resources.referral-users.name", 0)}
		>
			<Datagrid {...props} />
		</RaList>
	);
};

export default List;
